import { Component } from '@angular/core';
import { BaseListComponent } from '../base';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'gerenciamento-banca',
  templateUrl: './gerenciamento-banca.component.html'
})
export class GerenciarBancaComponent extends BaseListComponent {

  controllerName = 'gerenciamento-banca';
  filtro = this.formBuilder.group({
    query: [null]
  });
  showNotificacao = false;

  init() {
    this.listagem.pDatatableComponent.sortOrder = 2;
    this.service.ObterTodos(`${this.controllerName}/obterSituacoesBanca`).subscribe(
      data => {
        if (data) {
          this.showNotificacao = true;
        } else {
          this.showNotificacao = false;
        }
      }
    );
    this.carregarEstado();
  }


}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-banca/gerenciamento-banca.component.ts